import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const LPFooter = () => {
  return (
    <footer className="bg-[#012169] text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/assets/img/brand/logo-light.png" 
                alt="Crystal Trademark" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400">
              Professional USPTO trademark registration services by licensed IP attorneys.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-[#F97316] flex-shrink-0 mt-1" />
                <span>1680 N Vine St #315<br/>Los Angeles, CA 90028</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-[#F97316]" />
                <a href="tel:+18882032966" className="hover:text-[#F97316] transition-colors font-semibold">
                  +1 (888) 203-2966
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-[#F97316]" />
                <a href="mailto:info@crystaltrademark.com" className="hover:text-[#F97316] transition-colors">
                  info@crystaltrademark.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/" className="hover:text-[#F97316] transition-colors">Home</a></li>
              <li><a href="/about" className="hover:text-[#F97316] transition-colors">About Us</a></li>
              <li><a href="/contact" className="hover:text-[#F97316] transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Crystal Trademark. All rights reserved.
          </p>
          <div className="mt-4 flex items-center justify-center space-x-6 text-sm">
            <a href="/privacy" className="hover:text-[#F97316] transition-colors">Privacy Policy</a>
            <span className="text-gray-600">|</span>
            <a href="/terms" className="hover:text-[#F97316] transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
